import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import app from './modules/app';
import settings from './modules/settings';
import permission from './modules/permission';
import user from './modules/user';
import transaction from './modules/transaction';
import mvm from './modules/mvm';
import variable from './modules/variable';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    user,
    permission,
    transaction,
    mvm,
    variable,
  },
  getters,
});

export default store;
